"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVoiceProfilesResponseToJSON = exports.GetVoiceProfilesResponseFromJSONTyped = exports.GetVoiceProfilesResponseFromJSON = exports.instanceOfGetVoiceProfilesResponse = void 0;
var runtime_1 = require("../runtime");
var VoiceProfile_1 = require("./VoiceProfile");
/**
 * Check if a given object implements the GetVoiceProfilesResponse interface.
 */
function instanceOfGetVoiceProfilesResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetVoiceProfilesResponse = instanceOfGetVoiceProfilesResponse;
function GetVoiceProfilesResponseFromJSON(json) {
    return GetVoiceProfilesResponseFromJSONTyped(json, false);
}
exports.GetVoiceProfilesResponseFromJSON = GetVoiceProfilesResponseFromJSON;
function GetVoiceProfilesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'voiceProfiles': !(0, runtime_1.exists)(json, 'voice_profiles') ? undefined : (json['voice_profiles'].map(VoiceProfile_1.VoiceProfileFromJSON)),
    };
}
exports.GetVoiceProfilesResponseFromJSONTyped = GetVoiceProfilesResponseFromJSONTyped;
function GetVoiceProfilesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'voice_profiles': value.voiceProfiles === undefined ? undefined : (value.voiceProfiles.map(VoiceProfile_1.VoiceProfileToJSON)),
    };
}
exports.GetVoiceProfilesResponseToJSON = GetVoiceProfilesResponseToJSON;
